import { MD } from "components/core/new-button/button-component";

export default {
  buttonSize: MD,
  buttonText: "Button",
  isOpenLinkInNewTab: false,
  onClick: null
};
